import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { ReportDialogComponent, ReportDialogData } from '../../shared/report-dialog/report-dialog';
import { AssessmentFlag } from './feedback.types';

/**
 * *Flag this* (FLOW-347 DOC-79 §5A, FLOW-348 DOC-80 §4): the existing report
 * form, opened with the line — or the term — and its basis already filled in.
 * The same form, route and recipients as *Report a suggestion or bug*; only
 * what arrives changes. Flagging records nothing on the application.
 */
@Injectable({ providedIn: 'root' })
export class AssessmentFlagService {
  private readonly dialog = inject(MatDialog);

  open(flag: AssessmentFlag): Observable<string | null | undefined> {
    return this.dialog
      .open<ReportDialogComponent, ReportDialogData, string | null>(ReportDialogComponent, {
        width: '560px',
        maxWidth: '95vw',
        autoFocus: false,
        disableClose: true,
        data: { kind: 'BUG', flag },
      })
      .afterClosed();
  }
}
